import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { FirmwareService, PlatformType } from "../services/firmware/firmware.service";

@Component({
  selector: 'dcc-create-core-firmware-version',
  templateUrl: './create-core-firmware-version.component.html',
  styleUrls: ['./create-core-firmware-version.component.scss']
})
export class CreateCoreFirmwareVersionComponent {
  @Output() closePage: EventEmitter<any> = new EventEmitter();
  @Output() refreshPage: EventEmitter<any> = new EventEmitter();

  firmwareName: string = '';
  platformType: PlatformType;
  platformTypes = Object.values(PlatformType);
  firmwareVersionFile: File | undefined = undefined;
  fileName: string = '';
  isLoading: boolean = false;

  constructor(
    private toastr: ToastrService,
    private firmwareService: FirmwareService,
    private activeModal: NgbActiveModal
  ) { }

  onSelectVersionFile(event: Event) {
    let file = (event.target as HTMLInputElement);

    if (file.files) {
      let firmwareVersionFile = file.files[0];
      console.log('Selected file:', firmwareVersionFile);
      this.fileName = firmwareVersionFile.name;

      if (firmwareVersionFile.type !== 'application/zip' && !firmwareVersionFile.name.endsWith('.zip')) {
        this.toastr.error('Please upload a valid zip file.');
        this.firmwareVersionFile = null;
        this.fileName = '';
        return;
      }
      this.firmwareVersionFile = firmwareVersionFile;
    }
  }

  close() {
    this.closePage.emit();
    this.activeModal.close(false);
  }

  async create() {
    if (!this.isFirmwareVersionValid())
      return

    if (!this.firmwareName || !this.platformType) {
      console.error('Please provide both name and platform type.');
      return;
    }
    if (this.firmwareVersionFile && this.firmwareName && this.platformType) {
      this.isLoading = true;
      this.firmwareService.createFirmwareVersion(this.platformType, this.firmwareName, this.firmwareVersionFile).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.toastr.success('Created Firmware Version: ' + this.firmwareName);
          this.refreshPage.emit();
          this.close();
        },
        error: error => {
          this.isLoading = false;
          this.toastr.error('Upload error:', error);
        }
      });
    } else {
      console.error('Please select a file, enter a name, and choose a platform type.');
    }
  }

  isFirmwareVersionValid(): boolean {
    if (!this.firmwareName) {
      this.toastr.warning(`Cannot create Firmware Version without a name`);
      return false;
    }
    if (!this.platformType) {
      this.toastr.warning(`Cannot create Firmware Version without a Platform Type`);
      return false;
    }
    if ((!this.firmwareVersionFile)) {
      this.toastr.warning(`Cannot create Firmware Version without a Valid Version File`);
      return false;
    }

    return true;
  }
}

